import MagicHeader from '../../widgets/MagicHeader';
import MomentsCart from '../../widgets/MomentsCart';
import '../magic.css';

const Cart = () => {
  return (
    <div className="magic-theme-light">
      <MagicHeader variant="light" showBack onBack={() => window.history.back()} hideActions />
      <main className="page-content strict-width x-space-top">
        <h4 className="title mb-3">My Moments</h4>
        <MomentsCart />
      </main>
    </div>
  );
};

export default Cart;
